import React, { useEffect, useRef, useState } from "react";
import "./Message.css";
import { Button, Card, Col, Modal, NavLink, Row } from "react-bootstrap";
import ChatBox from "./ChatBox";
import axios from "../../API/axios";
import { getConnectionList, getUserAllChat, getMessageList as fetchMessageList, getMessageCounts, loadMessagePageInitialData, parseMessageListResponse, syncUnreadMessageCountFromChats } from "../../Services/apiService";
import {
  normalizeChatList,
  mergeChatListReadStatus,
  mergeChatListDeleteStatus,
  mergeCachedPartnerReadReceipts,
  applyReadReceiptsToChatList,
  applyUnreadReceiptsToChatList,
  applyReadAllHubReceipt,
  applyDeleteHubToChatList,
  resolvePartnerFromReadHub,
  isReadReceiptRelevant,
  isDeleteHubRelevant,
  isReplyChatRelevant,
  resolvePartnerFromReplyChat,
  applyReplyChatToMessageList,
  appendReplyChatToChatList,
  getChatUnreadCount,
  cachePartnerSentMessagesRead,
  clearPartnerSentMessagesReadCache,
  syncPartnerReadCacheFromHub,
  logReadReceipt,
  uid,
} from "../../utils/chatReadUtils";
import { onHubEvent, startRealtimeHub } from "../../Services/realtimeHubService";
import { enrichChatWithReplyQuote, enrichChatListWithReplyQuotes } from "../../utils/messageReplyUtils";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { people } from "../../config/imagesLink";
import moment from "moment/moment";
import { Link, useNavigate, useParams } from "react-router-dom";
import MessageList from "./MessageList";
import ArchivedMessage from "./ArchivedMessage";
import { ShimmerDiv } from "@skeleton";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import AddSharpIcon from '@mui/icons-material/AddSharp';
import MailOutlineSharpIcon from '@mui/icons-material/MailOutlineSharp';
import { useTranslation } from "react-i18next";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";

const Message = ({ setShowT, setNoticationDataT, showT, notificationDataT,MessagesCount }) => {
  const sessionId = localStorage.getItem("sessionId");
  const { UserId } = useParams();
  const [msgId, setMsgId] = useState("");
  const [connectionUser, setConnectionUser] = useState("");
  const [userName, setUserName] = useState("");
  const [chatList, setChatList] = useState([]);
  const { t } = useTranslation();
  //************************Message List Start  ************************//
  const [isLoading, setIsLoading] = useState(true);
  const [messageList, setmessageList] = useState([]);
  const [show, setShow] = useState(false);
  const [newUser, setNewUser] = useState(false);
  const [page, setPage] = useState(1);
  const [active, setActive] = useState();
  const [archiveActive, setArchiveActive] = useState();
  const [archiveMessage, setArchiveMessage] = useState(false);
  const [allUserChats, setAllUserChats] = useState({});
  const language = localStorage.getItem("Lang");
  const [refreshChat, setRefreshChat] = useState(false);
const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [ArchdmsgCount, setArchdMsgCount] = useState(0);
  const [allmsgCount, setAllMsgCount] = useState(0);
  const [messageListPage, setMessageListPage] = useState(0);
  const [hasMoreMessageList, setHasMoreMessageList] = useState(true);
  const [isLoadingMoreMessages, setIsLoadingMoreMessages] = useState(false);
  const [activeTab, setActiveTab] = useState(1);

  const archivedCountTimerRef = useRef(null);
  const sidebarRefreshTimerRef = useRef(null);
  const messageListRef = useRef(messageList);
  const messageScrollerRef = useRef(null);
  const messageListPageRef = useRef(messageListPage);
  const hasMoreMessageListRef = useRef(hasMoreMessageList);
  const isLoadingMoreMessagesRef = useRef(isLoadingMoreMessages);
  const activeTabRef = useRef(1);

  const MESSAGE_LIST_PAGE_SIZE = 10;

  useEffect(() => {
    messageListRef.current = messageList;
  }, [messageList]);

  useEffect(() => {
    messageListPageRef.current = messageListPage;
  }, [messageListPage]);

  useEffect(() => {
    hasMoreMessageListRef.current = hasMoreMessageList;
  }, [hasMoreMessageList]);

  useEffect(() => {
    isLoadingMoreMessagesRef.current = isLoadingMoreMessages;
  }, [isLoadingMoreMessages]);

  useEffect(() => {
    activeTabRef.current = activeTab;
  }, [activeTab]);

  const extractMessageListItems = (response) => parseMessageListResponse(response);

  const mergeMessageListItems = (prev, next) => {
    const previous = Array.isArray(prev) ? prev : [];
    const incoming = Array.isArray(next) ? next : [];
    if (!previous.length) return incoming;
    if (!incoming.length) return previous;

    const seen = new Set(
      previous.map((item) => String(item?.chatInfo?.toUserUid ?? item?.chatID ?? ""))
    );

    const uniqueIncoming = incoming.filter((item) => {
      const key = String(item?.chatInfo?.toUserUid ?? item?.chatID ?? "");
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    return [...previous, ...uniqueIncoming];
  };

  const applyMessageListResponse = (response, { append = false } = {}) => {
    if (!response) return;
    setIsLoading(false);
    const items = extractMessageListItems(response);
    const chatId = response.data.responseData?.chatID;
    if (chatId != null) {
      localStorage.setItem("MessageChatId", chatId);
    }

    console.log("GetMessageList===>", items);

    setmessageList((prev) => {
      const next = append ? mergeMessageListItems(prev, items) : items;
      if (Array.isArray(next)) {
        syncUnreadMessageCountFromChats(next);
      }
      return next;
    });

    setHasMoreMessageList(items.length >= MESSAGE_LIST_PAGE_SIZE);
  };

  const applyMessageCountsResponse = (response) => {
    if (!response) return;
    setArchdMsgCount(response.data.responseData.archiveMsgslistCount);
    setAllMsgCount(response.data.responseData.allMsgslistCount);
  };

  const ArchivedMsgCount = async ({ forceRefresh = false } = {}) => {
    try {
      const resData = await getMessageCounts({ forceRefresh });
      applyMessageCountsResponse(resData);
    } catch (error) {
      console.log(error);
    }
  };

  const scheduleArchivedMsgCount = (forceRefresh = false) => {
    if (archivedCountTimerRef.current) {
      clearTimeout(archivedCountTimerRef.current);
    }
    archivedCountTimerRef.current = setTimeout(() => {
      ArchivedMsgCount({ forceRefresh });
    }, 400);
  };

  const getMessageList = ({
    forceRefresh = false,
    updateCounts = true,
    resetPagination = true,
    silent = false,
  } = {}) => {
    if (resetPagination) {
      setMessageListPage(0);
      setHasMoreMessageList(true);
      if (!silent) {
        setIsLoading(true);
      }
    }

    return fetchMessageList({
      forceRefresh,
      variant: "page",
      pageNumber: 0,
      pageSize: MESSAGE_LIST_PAGE_SIZE,
      topCount: null,
    })
      .then((response) => {
        applyMessageListResponse(response);
        if (updateCounts) {
          scheduleArchivedMsgCount(forceRefresh);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setIsLoadingMoreMessages(false);
        console.log(error);
      });
  };

  const loadMoreMessageList = () => {
    if (
      isLoadingMoreMessagesRef.current ||
      !hasMoreMessageListRef.current ||
      activeTabRef.current !== 1
    ) {
      return;
    }

    const nextPage = messageListPageRef.current + 1;
    isLoadingMoreMessagesRef.current = true;
    setIsLoadingMoreMessages(true);

    fetchMessageList({
      forceRefresh: false,
      variant: "page",
      pageNumber: nextPage,
      pageSize: MESSAGE_LIST_PAGE_SIZE,
      topCount: null,
    })
      .then((response) => {
        if (!response) return;
        applyMessageListResponse(response, { append: true });
        setMessageListPage(nextPage);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        isLoadingMoreMessagesRef.current = false;
        setIsLoadingMoreMessages(false);
      });
  };

  const handleMessageListScroll = () => {
    const scroller = messageScrollerRef.current;
    if (!scroller) return;

    const nearBottom =
      scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 80;

    if (nearBottom) {
      loadMoreMessageList();
    }
  };

  const scheduleMessageListRefresh = (forceRefresh = false) => {
    if (sidebarRefreshTimerRef.current) {
      clearTimeout(sidebarRefreshTimerRef.current);
    }
    sidebarRefreshTimerRef.current = setTimeout(() => {
      getMessageList({ forceRefresh, silent: true });
    }, 500);
  };

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setMessageListPage(0);
    setHasMoreMessageList(true);

    loadMessagePageInitialData()
      .then(([listRes, countsRes]) => {
        if (cancelled) return;
        applyMessageListResponse(listRes);
        applyMessageCountsResponse(countsRes);
      })
      .catch((error) => {
        if (!cancelled) {
          setIsLoading(false);
        }
        console.log(error);
      });

    return () => {
      cancelled = true;
      if (archivedCountTimerRef.current) {
        clearTimeout(archivedCountTimerRef.current);
      }
      if (sidebarRefreshTimerRef.current) {
        clearTimeout(sidebarRefreshTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!UserId || UserId === "All") return;

    setmessageList((prev) => {
      if (!Array.isArray(prev)) return prev;

      let changed = false;
      const next = prev.map((item) => {
        if (String(item.chatInfo?.toUserUid) !== String(UserId)) return item;
        if (getChatUnreadCount(item) === 0) return item;

        changed = true;
        return {
          ...item,
          unreadCount: 0,
          lastMsgIsRead: true,
          chatInfo: item.chatInfo
            ? { ...item.chatInfo, unreadCount: 0 }
            : item.chatInfo,
        };
      });

      if (changed) {
        syncUnreadMessageCountFromChats(next);
      }

      return changed ? next : prev;
    });
  }, [UserId]);

  useEffect(() => {
    let cancelled = false;
    const unsubscribers = [];

    const setup = async () => {
      try {
        await startRealtimeHub();
        if (cancelled) return;
        console.warn("[ReadReceipt] Message page hub listeners ready");
      } catch (error) {
        console.error("[ReadReceipt] Hub connect failed on Message page", error);
        return;
      }

      unsubscribers.push(
        onHubEvent("ReplyChat", (message) => {
          const openChatUserUid = localStorage.getItem("toUserUid");
          const userUid = localStorage.getItem("userUid");

          if (!isReplyChatRelevant(message, userUid)) return;

          const partnerUid = resolvePartnerFromReplyChat(message, userUid);
          let needsRefresh = false;

          setmessageList((prev) => {
            if (!Array.isArray(prev)) return prev;
            const next = applyReplyChatToMessageList(
              prev,
              message,
              userUid,
              openChatUserUid
            );
            if (next !== prev) {
              syncUnreadMessageCountFromChats(next);
            }
            if (next === prev) needsRefresh = true;
            return next;
          });

          if (needsRefresh) {
            scheduleMessageListRefresh(true);
          }

          if (
            partnerUid &&
            uid(partnerUid) !== uid(openChatUserUid)
          ) {
            setAllUserChats((prev) => {
              if (!prev?.[partnerUid]) return prev;
              const partnerItem = messageListRef.current?.find?.(
                (item) => uid(item.chatInfo?.toUserUid) === uid(partnerUid)
              );
              const partnerName = partnerItem?.chatInfo?.toUserFullName || "";
              const enriched = enrichChatWithReplyQuote(
                message,
                prev[partnerUid],
                partnerName,
                t("Notifications.You"),
                userUid
              );
              return {
                ...prev,
                [partnerUid]: appendReplyChatToChatList(
                  prev[partnerUid],
                  enriched,
                  userUid,
                  partnerName
                ),
              };
            });
          }
        })
      );

      unsubscribers.push(
        onHubEvent("ReadChat", (message) => {
          const openChatUserUid = localStorage.getItem("toUserUid");
          const userUid = localStorage.getItem("userUid");
          const partnerUid =
            resolvePartnerFromReadHub(message, userUid) || openChatUserUid;

          logReadReceipt("ReadChat (Message)", message);

          if (!isReadReceiptRelevant(message, partnerUid, userUid)) return;

          syncPartnerReadCacheFromHub(message, partnerUid);

          setChatList((prev) => {
            if (!Array.isArray(prev)) return prev;
            return applyReadReceiptsToChatList(prev, message, userUid, partnerUid);
          });

          if (partnerUid) {
            setAllUserChats((prev) => {
              if (!prev?.[partnerUid]) return prev;
              return {
                ...prev,
                [partnerUid]: applyReadReceiptsToChatList(
                  prev[partnerUid],
                  message,
                  userUid,
                  partnerUid
                ),
              };
            });
          }

          scheduleMessageListRefresh(false);
        })
      );

      unsubscribers.push(
        onHubEvent("UnReadChat", (message) => {
          const openChatUserUid = localStorage.getItem("toUserUid");
          const userUid = localStorage.getItem("userUid");
          const partnerUid =
            resolvePartnerFromReadHub(message, userUid) || openChatUserUid;

          logReadReceipt("UnReadChat (Message)", message);

          if (!isReadReceiptRelevant(message, partnerUid, userUid)) return;

          if (partnerUid) clearPartnerSentMessagesReadCache(partnerUid);

          setChatList((prev) => {
            if (!Array.isArray(prev)) return prev;
            return applyUnreadReceiptsToChatList(prev, message, userUid, partnerUid);
          });

          if (partnerUid) {
            setAllUserChats((prev) => {
              if (!prev?.[partnerUid]) return prev;
              return {
                ...prev,
                [partnerUid]: applyUnreadReceiptsToChatList(
                  prev[partnerUid],
                  message,
                  userUid,
                  partnerUid
                ),
              };
            });
          }

          scheduleMessageListRefresh(false);
        })
      );

      unsubscribers.push(
        onHubEvent("ReadAllChat", (messages) => {
          const openChatUserUid = localStorage.getItem("toUserUid");
          const userUid = localStorage.getItem("userUid");

          logReadReceipt("ReadAllChat (Message)", messages);

          setChatList((prev) => {
            const result = applyReadAllHubReceipt({
              hubData: messages,
              userUid,
              openPartnerUid: openChatUserUid,
              chatList: prev,
              allUserChats: null,
            });
            return result.applied ? result.chatList : prev;
          });

          setAllUserChats((prev) => {
            const result = applyReadAllHubReceipt({
              hubData: messages,
              userUid,
              openPartnerUid: openChatUserUid,
              chatList: null,
              allUserChats: prev,
            });
            return result.applied ? result.allUserChats : prev;
          });

          scheduleMessageListRefresh(false);
        })
      );

      unsubscribers.push(
        onHubEvent("DeleteChat", (message) => {
          const openChatUserUid = localStorage.getItem("toUserUid");
          const userUid = localStorage.getItem("userUid");
          const partnerUid =
            resolvePartnerFromReadHub(message, userUid) || openChatUserUid;

          if (!isDeleteHubRelevant(message, partnerUid, userUid)) return;

          setChatList((prev) => {
            if (!Array.isArray(prev)) return prev;
            if (uid(openChatUserUid) !== uid(partnerUid)) return prev;
            return applyDeleteHubToChatList(prev, message, userUid, partnerUid);
          });

          if (partnerUid) {
            setAllUserChats((prev) => ({
              ...prev,
              [partnerUid]: applyDeleteHubToChatList(
                prev?.[partnerUid] || [],
                message,
                userUid,
                partnerUid
              ),
            }));
          }

          scheduleMessageListRefresh(false);
        })
      );
    };

    setup();

    return () => {
      cancelled = true;
      unsubscribers.forEach((unsub) => unsub());
    };
  }, []);

  //************************Message List End  ************************//

  //************************ Connection  List Start  ************************//
  const [MsgConnectionList, setMsgConnectionList] = useState([]);
  const [searchUserName, setSearchUserName] = useState("");
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const [msgSearchconnectList, setMsgSearchConnectList] = useState([])
  const [debouncedSearchM, setDebouncedSearchM] = useState(searchUserName);

  const MsgConnectionListAll = async (reset = false) => {
    const payload = {
      deviceType: "Web",
      sessionId,
      // pageNumber: page,
      pageNumber: reset ? 1 : page,
      pageSize: 10,
      type: "ConnectionList",
      search: debouncedSearchM,
            langKey: language === "en" ? "" : language,

    };

    try {
      setIsLoading(true);

      const res = await getConnectionList(payload);
      // force to array – covers null/undefined/''/object cases
      const viewListRaw = res?.data?.responseData?.viewList;
      const viewList = Array.isArray(viewListRaw) ? viewListRaw : [];

      if (debouncedSearchM !== "") {
        setMsgConnectionList([]);               // don’t mix results with search
        setMsgSearchConnectList(viewList);      // safe – always an array
      } else {
        setMsgSearchConnectList([]);
        setMsgConnectionList(prevState => {
          if (reset) return viewList;
          const prev = Array.isArray(prevState) ? prevState : [];
          const deduped = viewList.filter(
            item => !prev.some(p => p.cnctnId === item.cnctnId)
          );
          return [...prev, ...deduped];      // both sides guaranteed arrays
        });
      }
    } catch (error) {
      if ((error.code === "ERR_NETWORK" && sessionId) ||
        (error.code === "ERR_BAD_REQUEST" && sessionId)) {
        setUnauthorisedModal(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  
useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedSearchM(searchUserName);
  }, 500); // 🔹 500ms debounce delay

  return () => {
    clearTimeout(handler);
  };
}, [searchUserName]);

  useEffect(() => {
    if (show) {
      setPage(1);
      setMsgConnectionList([]);
      setMsgSearchConnectList([]);
      MsgConnectionListAll(true);   // force fresh load
    }
  }, [show]); 

  useEffect(() => {
    if (show && debouncedSearchM.trim()) {
      MsgConnectionListAll();
    }
  }, [debouncedSearchM]);
  //************************Connection List End ************************//

  const handelInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        // setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handelInfiniteScroll);
    return () => window.removeEventListener("scroll", handelInfiniteScroll);
  }, []);

  const handleSendMessage = (item) => {
    const userExistsInMessageList = messageList.some(
      (message) => message.chatInfo.toUserId === item.connectsWithUserUid
    );
    if (userExistsInMessageList) {
      // Perform the action if user exists in the message list
      // console.log("User exists in the message list");
      // Call the function you need to execute when user exists
    } else {
      setChatList("");
      setConnectionUser(item.connectsWithUserUid);
      setUserName(item.connectsWithUserName);
      setShow(false);
    }
  };

  //************************Archived List Start  ************************//
  const [archivedList, setArchivedList] = useState([]);
  const getArchivedList = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    axios
      .post(`Message/GetArchivedMessageList`, data)
      .then((response) => {

        const res = response.data.responseData; 

        setArchivedList(res);
        scheduleArchivedMsgCount(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //************************Archived List End  ************************//

  //************************Message List Start  ************************//
  const [isLoadingChat, setIsLoadingChat] = useState(true);

  const [chatInfo, setChatInfo] = useState("");
  const [chatInfoid, setChatInfoId] = useState(null);
  // console.log('chatList', chatList);
  const getChatList = ({ forceRefresh = false } = {}) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      toUserUid: UserId,
      pageNumber: 1,
      pageSize: 32,
    };
    localStorage.setItem("toUserUid", data.toUserUid);
    getUserAllChat(data, { forceRefresh })
      .then((response) => {
        if (!response) return;
        console.log("GetUserAllChat", response.data.responseData);
        setIsLoadingChat(false);
        const res = response.data.responseData.chatList;

        if (Array.isArray(res)) {
          const userUid = localStorage.getItem("userUid");
          setAllUserChats((prev) => {
            const prevForUser = Array.isArray(prev[UserId]) ? prev[UserId] : [];
            const normalized = normalizeChatList(res, UserId, userUid);
            const withCache = mergeCachedPartnerReadReceipts(normalized, UserId, userUid);
            const withDeletes = mergeChatListDeleteStatus(withCache, prevForUser);
            const merged = mergeChatListReadStatus(withDeletes, prevForUser, userUid, UserId);
            const partnerName =
              response.data.responseData.messageInfo?.toUserFullName || "";
            const withReplyQuotes = enrichChatListWithReplyQuotes(
              merged,
              partnerName,
              t("Notifications.You"),
              userUid
            );
            setChatList(withReplyQuotes);
            return { ...prev, [UserId]: withReplyQuotes };
          });
        } else {
          console.error("chatList is not an array", res);
          setChatList([]);
        }
        const messageInfo = response.data.responseData.messageInfo;
        setChatInfo(messageInfo);
        setChatInfoId(messageInfo?.msgID);
        localStorage.setItem("msgId", messageInfo?.msgID);
      })
      .catch((error) => {
        setIsLoadingChat(false);
        console.log(error);
      });
  };

  useEffect(() => {
    if (UserId && UserId !== "All") {
      localStorage.setItem("toUserUid", UserId);
      setChatList([]);
      setIsLoadingChat(true);
      getChatList();
    }
  }, [UserId]);

  //************************Message List End  ************************//

  const [showClear, setShowClear] = useState(false);
  // const [showDelete, setShowDelete] = useState(false);

  const [isShown, setIsShown] = useState(true);
  //console.log('isShown', isShown);
  useEffect(() => {
    if (!UserId || UserId === "All" || !Array.isArray(messageList)) return;
    const idx = messageList.findIndex(
      (item) => String(item?.chatInfo?.toUserUid) === String(UserId)
    );
    if (idx >= 0) setActive(idx);
  }, [UserId, messageList]);

  useEffect(() => {
    if (!UserId || UserId === "All" || !Array.isArray(archivedList)) return;
    const idx = archivedList.findIndex(
      (item) => String(item?.chatInfo?.toUserUid) === String(UserId)
    );
    if (idx >= 0) setArchiveActive(idx);
  }, [UserId, archivedList]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 1:
        return (
          <>
            <div
              className="message-scroller"
              ref={messageScrollerRef}
              onScroll={handleMessageListScroll}
            >
              {isLoading ? (
                <div className="mt-3">
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                </div>
              ) : (
                <>
                  {Array.isArray(messageList) &&
                    messageList.map((item, index) => {
                  return (
                    <MessageList
                      // showClear={showClear}
                      // setShowClear={setShowClear}
                      isShown={isShown}
                      // showDelete={showDelete}
                      // setShowDelete={setShowDelete}
                      getChatList={getChatList}
                      item={item}
                      archiveMessage={archiveMessage}
                      index={index}
                      active={active}
                      setActive={setActive}
                      UserId={UserId}
                      setMsgId={setMsgId}
                      getArchivedList={getArchivedList}
                      getMessageList={getMessageList}
                      setIsShown={setIsShown}
                      setChatList={setChatList}
                      notificationDataT={notificationDataT}
                    />
                  );
                    })}
                  {isLoadingMoreMessages ? (
                    <div className="message-list-load-more mt-2">
                      <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                      <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                    </div>
                  ) : null}
                </>
              )}
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div className="message-scroller">
              {isLoading ? (
                <div className="mt-3">
                  {/* <ShimmerThumbnail height={250} rounded /> */}
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />
                  <ShimmerDiv height={60} width={"100%"} className="mb-2" />

                </div>
              ) : (
                archivedList &&
                archivedList?.map((item, index) => {
                  return (
                    <ArchivedMessage
                      isShown={isShown}
                      getChatList={getChatList}
                      item={item}
                      archiveMessage={archiveMessage}
                      index={index}
                      archiveActive={archiveActive}
                      setArchiveActive={setArchiveActive}
                      setMsgId={setMsgId}
                      getArchivedList={getArchivedList}
                      getMessageList={getMessageList}
                      UserId={UserId}
                    />
                  );
                })
              )}
            </div>
          </>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes
    }
  }, [show]);

  // useEffect(() => {
  //   // If a userUid is present in the URL, show the message container
  //   if (UserId) {
  //     setIsShown(false); // Automatically show the message box when redirected with UserId
  //   }
  // }, [UserId]);
  // const navigate = useNavigate();
  // const handleBackToList = () => {
  //   // Navigate back to the message list by clearing userUid from the URL
  //   navigate('/Message/All');
  //   setIsShown(true)
  // };

  // ........................read all chat ............... 

  // const ReadAllChat = async () => {
  //     const messageDetails = {
  //       deviceType: "Web",
  //       sessionId: sessionId,  
  //       msgID: chatInfo?.msgID,
  //       toUserUid: UserId,
  //     };

  //     try {
  //       const response = await axios.post("Message/ReadAllChat", messageDetails);

  //       if (response.data.success) {
  //         // Update local chat list to mark all messages as read
  //         setChatList(prevList => 
  //           prevList.map(group => ({
  //             ...group,
  //             chats: group.chats.map(chat => ({
  //               ...chat,
  //               isRead: true
  //             }))
  //           }))
  //         );

  //         // Refresh the chat list to get updated status
  //         // getChatList();

  //         // Update the UI for message list
  //         // getMessageList();
  //       }
  //     } catch (error) {
  //       console.error("Error in ReadAllChat:", error);
  //     }
  // };

  return (
    <>
      <div
        className="row message-wrap Outermessage-wrap"
        style={{
          position: "relative",
          // zIndex: showClear || showDelete ? "2" : "1",
          zIndex: showClear ? "2" : "1",
        }}
      >
        <h4 onClick={() => setIsShown((current) => !current)} className={`${!isShown ? 'd-md-none d-block' : 'd-none'} back-button`} >  <span className="back-arrow">←</span>
        </h4>
        <div className="col-md-4 friends-list pe-lg-0 messageBoxNew">

          <Card className={`${isShown ? "d-block" : "d-md-block d-none"
            } main-card`}>
            <div
              className={`${isShown ? "d-flex" : " d-md-flex d-none"
                } chatListCont d-flex  p-3 align-items-center justify-content-between`}
            >
              <h2 className="f-20 f-600">{t("Notifications.Messages")} </h2>

              <button
                className="apply-btn newBtn d-flex align-items-center"
                onClick={() => {
                  setShow(true);
                }}
              >
                <AddSharpIcon className="material-symbols-sharp" />
                {t("Notifications.New")}
              </button>

            </div>
            <div className="tabButton d-flex p-3 w-100 ms-2 connectionTab">
              <NavLink
                onClick={() => {
                  setActiveTab(1);
                  setArchiveMessage(false);
                }}
                className={`text-center ${activeTab === 1 ? "activeTab" : ""}`}
              >
                <p className="f-14 tabName" onClick={() => getMessageList({ forceRefresh: true })}>{t("Notifications.All")} ({allmsgCount})</p>
              </NavLink>

              <NavLink
                onClick={() => {
                  setActiveTab(2);
                  setArchiveMessage(true);
                }}
                className={`text-center ${activeTab === 2 ? "activeTab" : ""}`}
              >
                <p className="f-14 tabName" onClick={getArchivedList}>{t("Notifications.Archived")} ({ArchdmsgCount}) </p>
              </NavLink>
            </div>
            <div className="resume-section">{renderTabContent()}</div>
          </Card>
        </div>
        {/* {console.log("chatList", chatList, UserId)} */}

        <div
          className={`${!isShown ? "d-block" : "d-md-block d-none"
            } col-md-8 messageBox ps-0  messageBoxSecondNew`
          }
          style={{ position: "relative" }}
        >
          {UserId === "unknown" ? (
            <div className=""></div>
          ) : (
            <ChatBox
              isShown={isShown}
              allUserChats={allUserChats}
              setAllUserChats={setAllUserChats}
              isLoadingChat={isLoadingChat}
              chatInfo={chatInfo}
              chatInfoid={chatInfoid}
              // ReadAllChat={ReadAllChat}
              getChatList={getChatList}
              userName={userName}
              chatList={chatList}
              setChatList={setChatList}
              UserId={UserId}
              msgId={msgId}
              connectionUser={connectionUser}
              getMessageList={getMessageList}
              setMsgId={setMsgId}
              setShow={setShowT}
              setNoticationData={setNoticationDataT}
              show={showT}
              notificationData={notificationDataT}
              MessagesCount={MessagesCount}
              archiveMessage={archiveMessage}
              getArchivedList={getArchivedList}
              activeConversation={
                Array.isArray(messageList)
                  ? messageList.find(
                      (item) =>
                        String(item?.chatInfo?.toUserUid) === String(UserId)
                    )
                  : null
              }
              messageList={messageList}
            />
          )}
        </div>
      </div>

      {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Sidemenubar.Connections")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShow(false);
                  }}
                />
              </div>
              <Row>
                <Col md="12 notification-wrap connection-card">
                  <div className="mb-4">
                    <input
                      type="email"
                      className="form-control p-2"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      placeholder={t("People.Search user")}
                      onChange={(e) => {
                        setSearchUserName(e.target.value);
                      }}
                      value={searchUserName}
                    />
                  </div>
                  {msgSearchconnectList.length === 0
                    ? MsgConnectionList &&
                    MsgConnectionList.map((item, index) => (
                      // console.log('ConnectionList', item),
                      <Card className="mb-1 message-cards" key={index}>
                        <Card.Body className="py-1">
                          <div className="d-lg-flex d-block align-items-center justify-content-between">
                            <img
                              src={
                                item.profilPic === ""
                                  ? people.DefaultProfile
                                  : item.profilPic
                              }
                              alt=""
                              height={40}
                              width={40}
                              style={{ borderRadius: "50px" }}
                              className="Company-card-Img"
                            />
                            <div className="ms-3">
                              <h6 className="notification-message lastseen mb-1">
                                {item.fullName}
                              </h6>
                              <p className="last ">{item.title}</p>
                              <p className="lastseen">{item.headLine}</p>
                              <p className="lastseen">
                                {item.followersCount} {t("People.Followers")}
                              </p>
                            </div>
                            <div className="ms-auto">
                              <Link
                                to={`/Message/${item.userUid}`}
                                onClick={() => {
                                  setShow(false);
                                }}
                              >
                                <button
                                  type="submit"
                                  className="wljSecondaryBtn d-flex align-items-center"
                                >
                                  <MailOutlineSharpIcon className="material-symbols-sharp" />{" "}
                                  {t("Notifications.Message")}
                                </button>
                              </Link>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))
                    : msgSearchconnectList &&
                    msgSearchconnectList.map((item, index) => (
                      // console.log('ConnectionList', item),
                      <Card className="mb-1 message-cards" key={index}>
                        <Card.Body className="py-1">
                          <div className="d-lg-flex d-block align-items-center justify-content-between">
                            <img
                              src={
                                item.profilPic === ""
                                  ? people.DefaultProfile
                                  : item.profilPic
                              }
                              alt=""
                              height={40}
                              width={40}
                              style={{ borderRadius: "50px" }}
                              className="Company-card-Img"
                            />
                            <div className="ms-3">
                              <h6 className="notification-message mb-1">
                                {item.fullName}
                              </h6>
                              <p className="lastseen">{item.title}</p>
                              <p className="lastseen">{item.headLine}</p>
                              <p className="lastseen">
                                {item.followersCount} {t("People.Followers")}
                              </p>
                            </div>
                            <div className="ms-auto">
                              <Link
                                to={`/Message/${item.userUid}`}
                                onClick={() => {
                                  setShow(false);
                                }}
                              // onClick={() => handleSendMessage(item)}
                              >
                                <button
                                  type="submit"
                                  className="wljSecondaryBtn d-flex align-items-center"
                                >
                                  <MailOutlineSharpIcon className="material-symbols-sharp" />{" "}
                                  {t("Notifications.Message")}
                                </button>
                              </Link>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    ))}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}
      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p">
                    {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal)
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem('hasModalShown');
                      }}
                    >
                      {t("modals.login")} 
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showToast && (
              <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
              />
            )}
      
            {showWarningToast && (
              <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
              />
            )}
            {showErrorToast && (
              <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
              />
            )}
      

    </>
  );
};

export default Message;
